export enum DoubleMaterialityQuestionTimeHorizon {
  Short,
  Medium,
  Long,
}
